// TermsNConditionsLogic.js
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";


export const getTermsNConditions = async (navigate, termId = 0, moduleName = "") => {
  const token = getToken();
  if (!token) {
    navigate && navigate('/login');
    throw new Error("No access token");
  }

  const url = `${dev_baseUrl}/TermsAndConditions/get?termId=${termId}&moduleName=${moduleName}`;
  const res = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json();

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching terms & conditions");
  }

  return data?.result || [];
};

export const saveTermsNConditions = async (navigate, payload) => {
  const token = getToken();
  if (!token) {
    navigate && navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(`${dev_baseUrl}/TermsAndConditions/save`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });
  const data = await res.json();

  if (!res.ok || data.isError) {
    throw new Error(data.message || "Error saving terms & conditions");
  }

  return data?.result || [];
};

export const deleteTermsNConditions = async (navigate, termId) => {
  const token = getToken();
  if (!token) {
    navigate && navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(`${dev_baseUrl}/TermsAndConditions/delete?termId=${termId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json();

  if (!res.ok || data.isError) {
    throw new Error(data.message || "Error deleting terms & conditions");
  }

  return data?.result || [];
};
